import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { roster } from '@squareup/dashboard-query/queries/roster';
import { type Location, Location_Status } from '@squareup/shared-types-protos/squareup/connect/v2/resources/location';

export function useActiveLocations() {
  return useQuery({
    ...roster.listLocations({}),
    select: (data) => ({
      ...data,
      locations: data.locations.filter(
        (location) => location.status === Location_Status.ACTIVE,
      ),
    }),
  });
}

export function useActiveLocationsByIdMap() {
  const { data: locationData } = useActiveLocations();
  return useMemo(() => {
    if (!locationData) {
      return {};
    }
    return locationData.locations.reduce((acc, location) => {
      if (!location.id) {
        return acc;
      }
      acc[location.id] = location;
      return acc;
    }, {} as Record<string, Location>);
  }, [locationData]);
}
